module.exports = __webpack_public_path__ + "img/20.6b681877.jpg";